var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spacer-wrap"},[(_vm.repeatText)?_c('div',{staticClass:"spacer-text"},[_vm._v("\n    "+_vm._s(_vm.repeatText)+"\n  ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }